import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function MessagesPage() {
  return <InstituteCrudPage config={entityConfigs['messages']} />;
}
